<template>
  <v-layout wrap v-if="editedItem">
    <h2 style="margin-bottom: 20px;"><v-icon color="black" style="margin-right: 10px;">mdi-wallet</v-icon>{{ editedID === 'new' ? $t('common.add', locale) : $t('common.edit', locale) }} link de pago</h2>
    <v-flex xs12>
      <v-text-field
        v-model="editedItem.Name"
        label="Nombre"
        outlined
        dense
      />
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model="editedItem.Concept"
        label="Concepto"
        outlined
        dense
      />
    </v-flex>
    <v-flex xs12 style="padding-bottom: 20px;">
      <v-text-field
        v-model="editedItem.Amount"
        label="Importe"
        outlined
        dense
        hideDetails
        :disabled="['paid', 'observation'].indexOf(editedItem.Status) >= 0"
      />
      <small style="margin-left:5px;color:gray;font-style: italic;">Informar siempre dos decimales Ej: <b>0.01</b></small>
    </v-flex>
    <v-flex xs12>
      <action-buttons
        v-if="editedItem"
        :id="editedItem.ID"
        :onDeleteItem="handleDelete"
        :onSaveItem="handleSave"
        :onClose="onClose"
        :locale="locale"
      />
    </v-flex>
  </v-layout>
</template>
<script>
const defaultItem = {
  ID: null,
  Name: '',
  PresentationID: '140181d0-aeff-11ed-9c29-f933aac7d201',
  Time: 15,
  Active: false,

}
import api from '@/services/api'
import utils from '@/services/utils'
import ActionButtons from '@/components/ActionButtons'
export default {
  components: {
    ActionButtons, 
  },
  props: {
    editedID: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      default: 'es',
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    editedItem: null,
  }),
  computed: {
    isMobile () {
      return utils.isMobile()
    },
    environment () {
      return 'payments'
    },
  },
  watch: {
    'editedID' () {
      this.handleGetData()
    },
    workspaceID () {
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleGetData () {
      if (!this.editedID) {
        this.editedItem = null
        return
      }
      if (this.editedID === 'new') this.editedItem = JSON.parse(JSON.stringify(defaultItem))
      else {
        const url = 'v1/private/payments/'
        api.getItem (this.environment, url, this.editedID)
          .then(response => {
            let item = JSON.parse(JSON.stringify(response))
            if (item.Amount) {
              let aux = item.Amount.toString().padStart(3, "0")
              let b = aux.substring(aux.length -2, aux.length)
              let a = aux.substring(0, aux.length -2)

              item.Amount = `${a}.${b}`
            }
            this.editedItem = item
          })
      }
    },
    prepareData () {
      this.item = JSON.parse(JSON.stringify(this.editedItem))
    },
    checkAmount (v) {
      if (!v) return false
      const aux = v.split('.')
      return aux.length === 2 && aux[0].length > 0 && aux[1].length === 2 ? `${aux[0]}${aux[1]}` : null
    },
    handleSave () {
      if (!this.editedItem.Name) {
        alert('El nombre es requerido')
        return
      }
      this.editedItem.Amount = this.checkAmount(this.editedItem.Amount)
      if (!this.editedItem.Amount) {
        alert('Formato no válido')
        return
      }

      const url = 'v1/private/payments/'
      if (!this.editedItem.ID) {
        // insert
        api.addItem (this.environment, url, this.editedItem)
          .then(() => {
            this.onClose(true)
          })
      } else {
        //update
        api.updateItem (this.environment, url, this.editedItem.ID, this.editedItem)
          .then(() => {
            this.onClose(true)
          })
      }
    },
    handleDelete () {
      if (['rejected', 'created'].indexOf(this.editedItem.Status)>=0) {
        const url = 'v1/private/payments/'
        api.deleteItem (this.environment, url, this.editedItem.ID)
          .then(() => {
            this.onClose(true)
          })
      } else {
        alert(`No se puede eliminar un pago con estado [${this.editedItem.Status}]`)
      } 
    },
  },
}
</script>
